import 'easymde/dist/easymde.min.css';
import React, { useState, useEffect } from 'react';
import { Editor } from '@tinymce/tinymce-react';
import tinymce from 'tinymce';

const TinyMceTextEditor = ({ label, id, value, setValue, maxLength, plugins, height, disableEnter }) => {
    const [count, setCount] = useState(0);
    const [editorRef, setEditorRef] = useState(null);

    const charCount = (editor) => editor?.plugins?.wordcount?.body?.getCharacterCount();
    const pluginsList = plugins ? plugins : [];

    const handleUpdate = (val, editor) => {
        const cCount = charCount(editor);
        if (maxLength) {
            if (cCount <= Number(maxLength)) {
                setValue(val);
                setCount(cCount);
            } else {
                setValue(value);
            }
        } else {
            setCount(cCount);
            setValue(val);
        }
    };

    useEffect(() => {
        handleAppendElement();
    }, [value]);

    useEffect(() => {
        if (editorRef) {
            const cCount = charCount(editorRef);
            setCount(cCount);
        }
    }, [editorRef]);

    useEffect(() => {
        setTimeout(() => {
            addAreaLable();
        }, 1000);
    }, []);

    const addAreaLable = () => {
        const ele = document?.querySelectorAll('.tox-toolbar__group');
        const resizeEle = document?.querySelectorAll('.tox-statusbar__resize-handle');
        if (ele?.length) {
            hideModalOnInsertLink();
            for (let i = 0; i < ele.length; i++) {
                let buttons = ele[i]?.getElementsByTagName('button');
                if (buttons?.length) {
                    for (let j = 0; j < buttons.length; j++) {
                        const ariaLabel = buttons[j]?.getAttribute('aria-label');
                        const svg = buttons[j]?.getElementsByTagName('svg')[0];
                        svg?.setAttribute('aria-label', ariaLabel);
                        svg?.setAttribute('role', 'img');
                    }
                }
            }
        }
        if (resizeEle?.length) {
            for (let i = 0; i < resizeEle.length; i++) {
                const ariaLabel = resizeEle[i]?.getAttribute('title');
                const svg = resizeEle[i]?.getElementsByTagName('svg')[0];
                svg?.setAttribute('aria-label', ariaLabel);
                svg?.setAttribute('role', 'img');
            }
        }
    };

    const handleAppendElement = () => {
        setTimeout(() => {
            if (maxLength) {
                let list = document?.getElementsByClassName('tox-statusbar__text-container');
                for (let i = 0; i < list.length; i++) {
                    list[i]?.appendChild(document?.getElementsByClassName('text-limit')[i]);
                }
            }
        }, 500);
    };

    const hideModalOnInsertLink = () => {
        document.querySelector('[title="Insert/edit link"]').addEventListener('click', function (e) {
            document.querySelector('.fade.modal.show').style.display = 'none';
            setTimeout(() => {
                document.querySelector('.tox-dialog__footer [title="Save"]').addEventListener('click', function (e) {
                    document.querySelector('.fade.modal.show').style.display = 'block';
                });
                document.querySelector('.tox-dialog__footer [title="Cancel"]').addEventListener('click', function (e) {
                    document.querySelector('.fade.modal.show').style.display = 'block';
                });
                document.querySelector('.tox-dialog__header [title="Close"]').addEventListener('click', function (e) {
                    document.querySelector('.fade.modal.show').style.display = 'block';
                });
            }, 200);
        });
    };

    return (
        <>
            {label && <label>{label}</label>}
            <Editor
                id={id}
                apiKey={process.env.REACT_APP_TINY_TOKEN}
                onInit={(evt, editor) => setEditorRef(editor)}
                value={value}
                onEditorChange={handleUpdate}
                init={{
                    height: height ? height : 300,
                    icons: 'material',
                    menubar: false,
                    paste_data_images: false,
                    paste_as_text: true,
                    browser_spellcheck: true,
                    plugins: [...pluginsList, 'lists', 'wordcount', 'autolink', 'link'],
                    toolbar: ' bold italic underline bullist numlist link unlink',
                    content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
                    content_css:
                        'https://common-assets-relay.s3.us-west-2.amazonaws.com/shared/style/tinymce-custom-style.css',
                    entity_encoding: 'raw',
                    entities: '&nbsp',
                    default_link_target: '_blank',
                    extended_valid_elements: 'a[href|target=_blank]',
                    urlconverter_callback: function (url, node, on_save, name) {
                        if (!url?.toLocaleLowerCase()?.includes('mailto:') && url.search('http') === -1) {
                            url = 'http://' + url;
                        }
                        // Return new URL
                        return url;
                    },
                    setup: disableEnter
                        ? function (ed) {
                              ed.on('keydown', function (e) {
                                  if (e.keyCode === 13) {
                                      e.preventDefault();
                                  }
                              });
                          }
                        : function (ed) {
                              ed.on('keydown', function (e) {
                                  if (window.location.href.includes('/systemsettings-btd')) {
                                      const cCount = charCount(ed);
                                      if (maxLength - cCount > 0) {
                                      } else if (e.key !== 'Backspace') {
                                          e.preventDefault();
                                      }
                                  }
                              });

                              ed.on('SetContent', function (e) {
                                  const cCount = tinymce?.activeEditor?.plugins?.wordcount?.body?.getCharacterCount();
                                  if (cCount) setCount(cCount);
                              });

                              ed.on('paste', function (e) {
                                  var clipboardData, pastedData, inputEditorData, selectedData, maxLengthNumber, total;
                                  clipboardData = e.clipboardData || window.clipboardData;
                                  pastedData = clipboardData.getData('Text');
                                  if (window.getSelection())
                                      selectedData = tinymce.activeEditor.selection
                                          .getContent({ format: 'text' })
                                          .toString()
                                          .replace(/\n|\r/g, '');
                                  maxLengthNumber = Number(maxLength);
                                  inputEditorData =
                                      tinymce.activeEditor.getBody().innerText.length - selectedData.length;
                                  total = inputEditorData + pastedData?.split(/\r|\r\n|\n/)?.length;
                                  if (total > maxLengthNumber) {
                                      e.stopPropagation();
                                      e.preventDefault();
                                  }
                              });
                          },
                }}
            />
            <p className="text-limit ms-2">{`${maxLength - count >= 0 ? maxLength - count : 0} characters`}</p>
        </>
    );
};

export default TinyMceTextEditor;
